import React, { useEffect, useRef } from "react"

interface NavigationItem {
  name: string
  url: string
  active: boolean
}

interface Props {
  items: NavigationItem[]
}

const Navigation = ({ items }: Props) => {
  const navList = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const activeElement = navList.current?.querySelector<HTMLLIElement>(".navigation__navLink--selected")?.closest("li")
    
    if (navList.current && activeElement) {
      navList.current.scrollLeft = Math.max(activeElement.getBoundingClientRect().x - 20, 0)
    }
  }, [])

  return (
    <nav className="navigation">
      <ul className="navigation__list" ref={navList}>
        {items.map((item) => {
          return <li key={item.name} className="navigation__list__item">
            <a className={`navigation__navLink${item.active ? " navigation__navLink--selected" : ""}`} href={item.url}>
              {item.name}
            </a>
          </li>
        })}
      </ul>
      <div className="specialOverlay" />
    </nav>
  )
}

export default Navigation